import { API_OFFLINE } from "@heraion/shared";

import type { TFn } from "./i18nTypes";

/** Offline is a state, not a fault: the cards that say it do not turn red. */
export const isOfflineCode = (code: string): boolean => code === API_OFFLINE;

/** #397: what a read that failed with nothing to show says: never the raw
 *  `api_error_*` code. Offline gets its own words, any other failure one. */
export const loadErrorText = (t: TFn, code: string): string =>
  isOfflineCode(code)
    ? t("mobile.progress.loadOffline", { defaultValue: "Offline: no data on this device yet" })
    : t("mobile.progress.loadFailed", { defaultValue: "Couldn’t load" });
